import aetna from '../../../images/insuranceLogos/light/aetna.svg'
import ambetter from '../../../images/insuranceLogos/light/ambetter.svg'
import amerihealth from '../../../images/insuranceLogos/light/amerihealth.svg'
import anthem from '../../../images/insuranceLogos/light/anthem.svg'
import beaconHealthOptions from '../../../images/insuranceLogos/light/beaconHealthOptions.svg'
import bluecrossBlueshield from '../../../images/insuranceLogos/light/bluecrossBlueshield.svg'
import brightHealth from '../../../images/insuranceLogos/light/brightHealth.svg'
import carefirst from '../../../images/insuranceLogos/light/carefirst.svg'
import cigna from '../../../images/insuranceLogos/light/cigna.svg'
import compsych from '../../../images/insuranceLogos/light/compsych.svg'
import firstHealth from '../../../images/insuranceLogos/light/firstHealth.svg'
import geha from '../../../images/insuranceLogos/light/geha.svg'
import guidewell from '../../../images/insuranceLogos/light/guidewell.svg'
import healthnet from '../../../images/insuranceLogos/light/healthnet.svg'
import healthpartners from '../../../images/insuranceLogos/light/healthpartners.svg'
import highmark from '../../../images/insuranceLogos/light/highmark.svg'
import humana from '../../../images/insuranceLogos/light/humana.svg'
import intermountainHealthcare from '../../../images/insuranceLogos/light/intermountainHealthcare.svg'
import kaiserPermanente from '../../../images/insuranceLogos/light/kaiserPermanente.svg'
import magellanHealth from '../../../images/insuranceLogos/light/magellanHealth.svg'
import medicaid from '../../../images/insuranceLogos/light/medicaid.svg'
import medicare from '../../../images/insuranceLogos/light/medicare.svg'
import mhn from '../../../images/insuranceLogos/light/mhn.svg'
import molinaHealthcare from '../../../images/insuranceLogos/light/molinaHealthcare.svg'
import multiplan from '../../../images/insuranceLogos/light/multiplan.svg'
import nhsUk from '../../../images/insuranceLogos/light/nhsUk.svg'
import optum from '../../../images/insuranceLogos/light/optum.svg'
import oscar from '../../../images/insuranceLogos/light/oscar.svg'
import tricare from '../../../images/insuranceLogos/light/tricare.svg'
import tuftsHealth from '../../../images/insuranceLogos/light/tuftsHealth.svg'
import unitedHealthcare from '../../../images/insuranceLogos/light/unitedHealthcare.svg'
import carelonBehavioralHealth from '../../../images/insuranceLogos/light/carelonBehavioralHealth.svg'
import ituFunds from '../../../images/insuranceLogos/light/ituFunds.svg'

export const lightInsuranceLogos = {
  aetna,
  amerihealth,
  ambetter,
  anthem,
  beaconHealthOptions,
  bluecrossBlueshield,
  brightHealth,
  carefirst,
  cigna,
  compsych,
  firstHealth,
  geha,
  guidewell,
  healthnet,
  healthpartners,
  highmark,
  humana,
  intermountainHealthcare,
  kaiserPermanente,
  magellanHealth,
  medicaid,
  medicare,
  mhn,
  molinaHealthcare,
  multiplan,
  nhsUk,
  optum,
  oscar,
  tricare,
  tuftsHealth,
  unitedHealthcare,
  carelonBehavioralHealth,
  ituFunds
}
